import React, { useEffect, useState } from "react";
import axios from "axios";
import NewsCard from "./NewsCard";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/news`;

const NewsEvents = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_BASE_URL}/getAll`);

      setNews(res.data.data || []);
    } catch (err) {
      console.error(err);
      setError("Unable to load News & Events.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      {/* Hero Section */}
      <section className="pt-36 pb-16 bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 relative overflow-hidden">
        {/* Decorative Blur */}
        <div className="absolute -top-32 -left-32 w-80 h-80 rounded-full blur-3xl"></div>

        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full blur-3xl"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-4xl text-center pl-80">

            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              News & Events
            </h1>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="max-w-7xl mx-auto px-6 py-10">
        {loading ? (
          <div className="flex justify-center py-24">
            <div className="w-14 h-14 border-[5px] border-orange-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : error ? (
          <div className="bg-white rounded-3xl shadow-xl border border-red-100 p-12 text-center max-w-xl mx-auto">
            <h2 className="text-3xl font-bold text-red-600">
              Something Went Wrong
            </h2>

            <p className="mt-4 text-gray-600 text-lg">
              {error}
            </p>
          </div>
        ) : news.length === 0 ? (
          <div className="bg-white rounded-3xl shadow-xl border border-gray-200 p-16 text-center">
            <h2 className="text-4xl font-bold text-[#0F172A]">
              No News Available
            </h2>

            <p className="mt-5 text-lg text-gray-500">
              News & Events will appear here once added by the admin.
            </p>
          </div>
        ) : (
          <>

            {/* Cards */}
            <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
              {news.map((item) => (
                <NewsCard
                  key={item._id}
                  news={item}
                />
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default NewsEvents;